import { useZakekeTranslations } from '@zakeke/zakeke-customizer-react';
import type { Tool } from 'photoeditorsdk';
import { useMemo } from 'react';

const usePhotoEditorTool = () => {
	const { T } = useZakekeTranslations();

	return useMemo(() => {
		const photoEditorLabelsFromBackend = [
			'transform', // optional
			'filter', // if active the tools, always active
			'focus', // optional
			'brush', // optional
			'frame', // optional
			'adjustment', // optional
			'overlay', // optional
			/* 'sticker', */ // not available in pm
			/* 'text', */ // not available in pm
			/* 'library', */ // not available in pm
		];

		const photoEditorToolsList = {
			filter: 'filter',
			focus: 'focus',
			transform: 'transform',
			brush: 'brush',
			frame: 'frame',
			adjustment: 'adjustment',
			overlay: 'overlay',
			// sticker: Tool.STICKER,
			// text: Tool.TEXT,
			// custom: Tool.CUSTOM,
			// library: Tool.LIBRARY,
		} as { [index: string]: Tool };

		const photoEditorToolsLabels = new Map([
			['transform', T._('Transform')],
			['filter', T._('Filter')],
			['focus', T._('Focus')],
			['brush', T._('Brush')],
			['frame', T._('Frame')],
			['adjustment', T._('Adjustment')],
			['overlay', T._('Overlay')],
			/* ['sticker', T._('Sticker')], */
			/* ['text', T._('Text')], */
			/* ['library', T._('Library')], */
		]);
		return {
			photoEditorToolsLabels,
			photoEditorLabelsFromBackend,
			photoEditorToolsList,
		};
	}, [T]);
};

export default usePhotoEditorTool;
